export default __webpack_public_path__ + "6e4b8979534d594910c4623c5bbf3a1f.png";